import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "address", "zip", "city", "customerSelect"]
  static values = { 
    customerId: Number,
    jobsitesUrl: String
  }

  connect() {
    // Warte bis das select Target verfügbar ist
    if (this.hasSelectTarget) {
      this.loadJobsites()
    }
    
    // Überwache Customer-Auswahl falls vorhanden
    if (this.hasCustomerSelectTarget) {
      this.customerSelectTarget.addEventListener('change', () => {
        this.loadJobsites()
      })
    }
  }

  async loadJobsites() {
    // Prüfe ob select Target verfügbar ist
    if (!this.hasSelectTarget) {
      return
    }
    
    // Hole die aktuelle Customer-ID - priorisiere das Select-Feld
    let customerId = null
    
    if (this.hasCustomerSelectTarget) {
      customerId = this.customerSelectTarget.value
    }
    
    // Fallback auf Value falls Select leer ist
    if (!customerId) {
      customerId = this.customerIdValue
    }
    
    if (!customerId) {
      // Leere das Select
      this.selectTarget.innerHTML = '<option value="">Standort auswählen (optional)</option>'
      return
    }

    try {
      const url = `${this.jobsitesUrlValue}/api_index?customer_id=${customerId}`
      
      const response = await fetch(url)
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      const jobsites = await response.json()
      
      // Leere das Select und füge Optionen hinzu
      this.selectTarget.innerHTML = '<option value="">Standort auswählen (optional)</option>'
      
      if (jobsites && jobsites.length > 0) {
        jobsites.forEach(jobsite => {
          const option = document.createElement('option')
          option.value = jobsite.id
          option.textContent = `${jobsite.title} - ${jobsite.city}`
          this.selectTarget.appendChild(option)
        })
      }
    } catch (error) {
      console.error('Fehler beim Laden der Jobsites:', error)
    }
  }

  selectJobsite(event) {
    const jobsiteId = event.target.value
    
    if (!jobsiteId) {
      this.clearAddressFields()
      return
    }

    // Lade Jobsite-Details
    this.loadJobsiteDetails(jobsiteId)
  }

  async loadJobsiteDetails(jobsiteId) {
    try {
      const response = await fetch(`${this.jobsitesUrlValue}/api_show/${jobsiteId}`)
      const jobsite = await response.json()
      
      // Fülle Adressfelder - überschreibe immer die Werte
      if (this.hasAddressTarget) {
        this.addressTarget.value = jobsite.address || ''
        this.addressTarget.dispatchEvent(new Event('input', { bubbles: true }))
      }
      if (this.hasZipTarget) {
        this.zipTarget.value = jobsite.zip || ''
        this.zipTarget.dispatchEvent(new Event('input', { bubbles: true }))
      }
      if (this.hasCityTarget) {
        this.cityTarget.value = jobsite.city || ''
        this.cityTarget.dispatchEvent(new Event('input', { bubbles: true }))
      }
    } catch (error) {
      console.error('Fehler beim Laden der Jobsite-Details:', error)
    }
  }

  clearAddressFields() {
    if (this.hasAddressTarget) {
      this.addressTarget.value = ''
      this.addressTarget.dispatchEvent(new Event('input', { bubbles: true }))
    }
    if (this.hasZipTarget) {
      this.zipTarget.value = ''
      this.zipTarget.dispatchEvent(new Event('input', { bubbles: true }))
    }
    if (this.hasCityTarget) {
      this.cityTarget.value = ''
      this.cityTarget.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }
}
